export const REMEDIAL_QUESTION = 'Remedial Question';
export const ADD_QUESTION = 'Add Question';
export const SEARCH = 'search'
export const SEARHC_QUESTION_ID = 'Search question id';
export const OR = 'OR';
export const CHOOSE_FROM_LIBRARY = 'Choose from Library';
export const ERROR_MESSAGE_CONTENT_ID = "Either content Id is not valid or it is a draft content.";
export const ERROR = "error";
export const ADD_COMMON_QSTN = 'Each question in Remedial Questions is tagged individually';
export const SUCCESS = 'success';
export const REMEDIAL_QUESTION_DELETE_TEXT = 'Are you sure you want to delete this Question';